import React from "react";
import { baseURL, headers } from "../../global/api";
import { connect } from "react-redux";
import MaterialTable from "@material-table/core";


const formatDate = (date) => {
    const d = new Date(date);

    return `${d.getUTCDate()} ${d.toLocaleString("en-US", {
        month: "short",
        timeZone: "UTC",
    })} ${d.getUTCFullYear()} ${d.getUTCHours()}:${String(
        d.getUTCMinutes()
    ).padStart(2, "0")}`;
};

const ViewMeetings = (props) => {
    return (
        <>
            <MaterialTable
                title="Meeting Details"
                columns={[
                    { title: "Event Type", field: "eventType" },
                    { title: "Name", field: "name" },
                    { title: "Meeting Start Time", field: "startTime", render: (rowData) => formatDate(rowData.startTime), },
                    { title: "Meeting End Time", field: "endTime", render: (rowData) => formatDate(rowData.endTime), },
                    { title: "Status", field: "status" },
                    { title: "Attendee", field: "email", render: rowData => rowData.attendees?.[0]?.email || "-" },
                    { title: "Log CreatedAt", field: "createdAt", render: (rowData) => formatDate(rowData.createdAt), },
                ]}
                data={(query) =>
                    new Promise((resolve, reject) => {
                        let url = `${baseURL}/user/get-meetings?`;
                        url += "limit=" + query.pageSize;
                        url += "&page=" + query.page;
                        url += "&search=" + query.search;

                        query.filters.forEach((filter) => {
                            url += `&${filter.column.field}=${filter.value}`;
                        });

                        fetch(url, {
                            method: "GET",
                            headers: headers,
                        }).then((response) => response.json()).then((result) => {
                            resolve({
                                data: result.data || [],
                                page: result.page,
                                totalCount: result.totalResults,
                            });
                        });
                    })
                }
                options={{
                    actionsColumnIndex: -1,
                    exportButton: true,
                    exportAllData: true,
                    paging: true,
                    pageSize: 50,
                    emptyRowsWhenPaging: false,
                    filtering: true,
                    debounceInterval: 700,
                    pageSizeOptions: [50, 100, 150, 200],
                    headerStyle: {
                        position: "sticky",
                        top: 0,
                        color: "#00BBBB",
                        fontWeight: "550",
                        onRowAdd: "none",
                        whiteSpace: 'nowrap',
                    },
                    rowStyle: {
                        whiteSpace: 'nowrap',
                    },
                    cellStyle: {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    },
                }}
            />
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {

    };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewMeetings);
